// extracted by mini-css-extract-plugin
export default {"flexGap2ItemsCenter":"shipping-field_flexGap2ItemsCenter__d4kYD","shippingDivider":"shipping-field_shippingDivider__IFKfq"};